import DataTable from "../../Reusable/DataTable/FleetDataTable";
import NACell from "../../Reusable/DataTable/NACell";
import APIS from "../../../constant/EndPoint";
import TableActionButton from "../../Reusable/TableActionButton";

const VehicleTypeList = () => {

  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.VEHILCE_TYPE}
      queryKey={"vehicle-type"}
      columns={defaultColumns}
      addNewPagePath={"/create-vehicle-type"}
      tableName={"Vehicle Type"}
    />
  );
};

export default VehicleTypeList;
